import { render, staticRenderFns } from "./DispatchParkAppointCard.vue?vue&type=template&id=7611ab40&"
import script from "./DispatchParkAppointCard.vue?vue&type=script&lang=js&"
export * from "./DispatchParkAppointCard.vue?vue&type=script&lang=js&"
import style0 from "./DispatchParkAppointCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports